const BOLETO_PENALTY_ENUM = {
  FINE: 'fine',
  INTEREST: 'interest'
}

export { BOLETO_PENALTY_ENUM }
